import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../app/axiosBaseQuery';

export const payoutsApi = createApi({
  reducerPath: 'payoutsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['MyPayouts', 'AdminPayouts', 'Investment'],
  endpoints: (builder) => ({
    triggerPaystackPayout: builder.mutation({
      query: ({ investmentId, ...body }) => ({ url: `/admin/investments/${investmentId}/payouts/paystack`, method: 'POST', data: body }),
      invalidatesTags: ['AdminPayouts', 'MyPayouts'],
    }),
    recordManualPayout: builder.mutation({
      query: ({ investmentId, ...body }) => ({ url: `/admin/investments/${investmentId}/payouts/manual`, method: 'POST', data: body }),
      invalidatesTags: ['AdminPayouts', 'MyPayouts'],
    }),
    myPayouts: builder.query({
      query: () => ({ url: '/me/payouts', method: 'GET' }),
      providesTags: ['MyPayouts'],
    }),
    adminListPayouts: builder.query({
      query: (params) => ({ url: '/admin/payouts', method: 'GET', params }),
      providesTags: ['AdminPayouts'],
    }),
  }),
});

export const {
  useTriggerPaystackPayoutMutation,
  useRecordManualPayoutMutation,
  useMyPayoutsQuery,
  useAdminListPayoutsQuery,
} = payoutsApi;
